import { render, staticRenderFns } from "./modalEditTransaction.vue?vue&type=template&id=0c1651da&"
import script from "./modalEditTransaction.vue?vue&type=script&lang=js&"
export * from "./modalEditTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports